import { render, staticRenderFns } from "./StartingMessage.vue?vue&type=template&id=97e8a3ea&scoped=true"
import script from "./StartingMessage.vue?vue&type=script&lang=js"
export * from "./StartingMessage.vue?vue&type=script&lang=js"
import style0 from "./StartingMessage.vue?vue&type=style&index=0&id=97e8a3ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e8a3ea",
  null
  
)

export default component.exports